import React, { Component } from 'react';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import { connect } from 'react-redux';
import { deleteNotification, getNotifications, readNotifications } from '../../store/actions';
import Loading from '../../components/spinner';
import './index.css';
import { NormalText, Subtitle, Title, Spacer, StrongText, SmallText } from '../../components/common';
import moment from 'moment';
import { forwardTo } from '../../lib/utils';
import { IonAlert, IonButton } from '@ionic/react';
import { getConfig } from '../../appConfig';
import { ReactComponent as NoMessagesIcon } from '../../assets/images/no-data-order-icon.svg';
import { ReactComponent as MailIcon } from '../../assets/images/mail.svg';

class Inbox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandNotificationBody: false,
      selectedMessage: null
    };

  }

  componentDidMount() {
    this.fetchNotifications();
  }
  fetchNotifications() {
    if (getConfig().flags.hasNotificationDetails) {
      this.props.dispatch(getNotifications());
    } else {
      this.props.dispatch(readNotifications());
    }
  }
  removeNotification(notification) {
    this.setState({ selectedMessage: null }, () => {
      this.props.dispatch(deleteNotification(notification.id));

    })
  }
    onRefreshHandler = (e) => {
      setTimeout(() => {
        this.fetchNotifications();
        e.target.complete();
      }, 2000);
    };
  render() {
    const { __, notifications } = this.props;
    const { expandNotificationBody, selectedMessage } = this.state
    const hasNotificationDetails = getConfig().flags.hasNotificationDetails
    return (
      <Loading transparent>
        <Layout
         withRefresher={true}
          onRefreshHandler={this.onRefreshHandler}
          showHamburger
          hideSecondToolbar={true}
          color="transparent"
          headerTitle={__('Inbox')}
        >
          <div className='scrollable-y absolute-content box-with-shadow'>

            {notifications?.filter(notification => !notification.is_deleted).length == 0 ?
              <div className="no-data-inbox">
                <MailIcon />
                <Spacer size={1} />
                <Title>{__('No messages')}</Title>
                <Spacer size={1} />
                <NormalText>{__("Looks like you don't have any notifications.")}</NormalText>
              </div>

              : <Title className='page-title-centered'>{__('Inbox')}</Title>

            }
            {notifications?.filter(notification => !notification.is_deleted)?.map((el, index) => (

              <div className='notification-wrapper box-content' onClick={() => hasNotificationDetails ? forwardTo(`/notification/${el.id}`) : () => { }}>
                <div className='notification-header' >
                  <div className='notification-header-icon'>

                    <MailIcon />
                  </div>
                  <div style={{ flex: 1 }}>
                    <StrongText>{el.notification_title}</StrongText>
                    <SmallText className='color-light'>{moment(el.created_at).format('DD MMM, YYYY h:mm A')}</SmallText>
                  </div>
                  {(hasNotificationDetails ? !el.is_read : moment().diff(moment(el.created_at), 'hours') <= 24) &&
                    <div className='notification-status'>{__('NEW')}</div>
                  }
                </div>
                <div className='notification-content'>
                  {hasNotificationDetails ? <>
                    <NormalText className='block notification-preview'>
                      <div dangerouslySetInnerHTML={{ __html: el.notification_body }} />
                    </NormalText>
                    <IonButton color={'secondary'} onClick={(e) => { e.stopPropagation(); this.setState({ selectedMessage: el }) }} className='link small-btn'>{__('Delete')}</IonButton>

                  </> : <>

                    {el.notification_body.length < 100 ? <>


                      <div className='normal-text' dangerouslySetInnerHTML={{ __html: el.notification_body }} />
                      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>

                        <IonButton color={'secondary'} onClick={() => this.setState({ selectedMessage: el })} className='link  small-btn'>{__('Delete')}</IonButton>
                      </div>
                    </> : <>

                      {(expandNotificationBody === index) ?
                        <div className='normal-text' dangerouslySetInnerHTML={{ __html: el.notification_body }} />
                        :
                        <>
                          <div className='normal-text' dangerouslySetInnerHTML={{ __html: el.notification_body.slice(0, 100) }} />

                        </>
                      }
                      <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
                        <IonButton color={'secondary'} onClick={() => this.setState({ expandNotificationBody: this.state.expandNotificationBody === index ? false : index })} className='link  small-btn'>{(expandNotificationBody === index) ? __('Show less') : __('Show more')}</IonButton>
                        <IonButton color={'secondary'} onClick={() => this.setState({ selectedMessage: el })} className='link  small-btn'>{__('Delete')}</IonButton>
                      </div>


                    </>}

                  </>}
                </div>
              </div>
            ))}
          </div>
          <IonAlert
            isOpen={selectedMessage !== null}
            onDidDismiss={() => this.setState({ selectedMessage: null })}
            message={`${__('Are you sure you want to delete this message')}`}
            buttons={[
              {
                text: __('Delete'),
                cssClass: 'primary',
                handler: () => this.removeNotification(selectedMessage),
              },
              {
                text: __('Cancel'),
                role: 'cancel',
                cssClass: 'secondary link',
              },

            ]}
          />
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  return {
    notifications: state.profile.notifications || [],
  };
};

export default connect(stateToProps)(withTranslation(Inbox));
